import PropTypes from 'prop-types';

const contact = PropTypes.shape({
  homeTelephone: PropTypes.string,
  workTelephone: PropTypes.string,
  mobileTelephone: PropTypes.string,
  fax: PropTypes.string,
  bleeper: PropTypes.string,
  email1: PropTypes.string,
  email2: PropTypes.string,
  webAddress: PropTypes.string,
});

export default contact;
